import { NavigationGuardNext, Route } from 'vue-router'

import store from '@/store'

function isExpiredGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  const isExpired = store.getters['subscription/isExpired']
  const inGrace = store.getters['subscription/inGrace']
  const graceType = store.getters['subscription/graceType']
  const firstLoad = !from.matched?.length

  if (!isExpired && !(inGrace && graceType === 'recurring' && firstLoad)) {
    return next({ name: 'billing:billing-history' })
  }

  return next()
}

export default isExpiredGuard
